import { CMSLink } from '../CMSLink';
import { GeneralInformation } from '@/payload-types';
import { CMSLinkType } from '@/types/CMSLink';

type navItemsFromGeneralInformation = NonNullable<
  GeneralInformation['navigationItems']
>;
type navItemFromNavItem = navItemsFromGeneralInformation[number];

export function MobileNavLink({
  href,
  parent,
  className,
  closeMenu,
}: {
  href: navItemFromNavItem;
  parent?: CMSLinkType | null;
  className?: string;
  closeMenu?: () => void;
}) {
  return (
    <div className={`block w-full p-2 ${className}`} onClick={closeMenu}>
      <CMSLink {...href.link} parentUrl={parent ? parent : null} />
    </div>
  );
}
